// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AcoesMarketing_UploadFotoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /marketing/acoes/upload_foto
 *
 * Multipart form: `foto` (image file). Same artefacts as SiteUnidades_UploadFotoInput:
 * the file lives in $_FILES, the JSON contract layer is bypassed.
 */
import { registerContract } from './validate'

export interface AcoesMarketing_UploadFotoInput {
_files: unknown[]
}

registerContract('AcoesMarketing_UploadFotoInput', {
  _files: { type: 'array',   required: true },
})
